import { Label } from 'reactstrap';
import SwitchInput from '../basics/SwitchInput';
import { useUnassignedStemsContext } from '../../contexts/UnassignedStemsContext';

const UnassignedStemsSwitch = () => {
  const {
    includeUnassignedStems,
    setIncludeUnassignedStems,
  } = useUnassignedStemsContext();

  return (
    <div className="d-flex justify-content-between align-items-center">
      <Label className="m-0">Include unassigned stems</Label>
      <SwitchInput
        checked={includeUnassignedStems}
        onChange={() => setIncludeUnassignedStems((current) => !current)}
      />
    </div>
  );
};

export default UnassignedStemsSwitch;
